
import React from 'react';
import TeachingReportForm from '../components/form/TeachingReportForm';

const FormPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-form-blue text-white py-6 shadow-md">
        <div className="container max-w-4xl mx-auto px-4">
          <h1 className="text-2xl md:text-3xl font-bold">แบบฟอร์มรายงานการสอน</h1>
          <p className="mt-2 text-blue-100">กรุณากรอกข้อมูลให้ครบถ้วน เพื่อความถูกต้องในการประเมินผลการสอน</p>
        </div>
      </header>

      <main className="container max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
          <TeachingReportForm />
        </div>
      </main>
    </div>
  );
};

export default FormPage;
